<template>
  <div>
    <el-card class="box-card" v-if="permissions.indexOf('列表') > -1">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth" :inline="true">
        <el-form-item label="名字" prop="name">
          <el-input v-model="searchForm.name" placeholder="请输入名字" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="searchForm.mobile" placeholder="请输入手机号" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <a class="mainColor mr" @click="reset" icon="el-icon-refresh">重置</a>
          <el-button :size="buttonSize" type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
          <!-- <el-button :size="buttonSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row>
        <el-col :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            v-if="permissions.indexOf('新增') > -1"
          >新增</el-button>
          <el-button
            :size="buttonSize"
            type="danger"
            @click="batchDeleteUser"
            icon="el-icon-minus"
            v-if="permissions.indexOf('批量删除') > -1"
          >批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            v-if="permissions.indexOf('导入') > -1"
          >导入</el-button>
          <el-button
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            v-if="permissions.indexOf('导出') > -1"
          >导出</el-button>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
        v-if="permissions.indexOf('列表') > -1"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="department.name" label="部门"></el-table-column>
        <el-table-column prop="name" label="名字"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="roles" label="角色">
          <template slot-scope="scope">
            <div v-for="item in scope.row.roles" :label="item">{{ item.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="lastLoginTime" label="上次登录"></el-table-column>
        <el-table-column prop="active" label="状态" align="center">
          <template slot-scope="scope">
            <div class="operation-group">
              <!--<span v-if="scope.row.active == -1" @click="enableUser(scope.row, 1)">启用</span>-->
              <!--<span v-else="scope.row.active == 1" @click="enableUser(scope.row, -1)">禁用</span>-->
              <span class="success" v-if="scope.row.active == 1">启用</span>
              <span class="danger" v-else>禁用</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operation-group">
              <span
                @click="selection = scope.row.id, editFormVisible = true"
                v-if="permissions.indexOf('编辑') > -1"
              >
                <i class="el-icon-edit"></i>编辑
              </span>
              <span @click="deleteUser(scope.row)" v-if="permissions.indexOf('删除') > -1">
                <i class="el-icon-delete"></i>删除
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
        v-if="permissions.indexOf('列表') > -1"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="新增用户"
      :visible.sync="addFormVisible"
      :width="dialogWidth"
      left
      v-if="permissions.indexOf('新增') > -1"
    >
      <el-form
        :inline="true"
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-form-item label="所属部门">
          <el-select v-model="addForm.departmentId" placeholder="请选择" clearable>
            <el-option-group
              v-for="group in addForm.departments"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="item in group.departments"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roles">
          <el-select v-model="addForm.roles" multiple placeholder="请选择角色" clearable>
            <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="addForm.username"
            placeholder="请输入账号"
            auto-complete="off"
            maxlength="64"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="addForm.password"
            placeholder="请输入密码"
            auto-complete="off"
            maxlength="64"
            clearable
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="名字" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入名字"
            auto-complete="off"
            maxlength="64"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="addForm.sex" placeholder="请选择性别" clearable>
            <el-option v-for="item in sexs" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="addForm.mobile"
            placeholder="请输入手机号"
            auto-complete="off"
            maxlength="16"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="固定电话" prop="telephone">
          <el-input
            v-model="addForm.telephone"
            placeholder="请输入固定电话"
            auto-complete="off"
            maxlength="16"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="addForm.email"
            placeholder="请输入邮箱"
            auto-complete="off"
            maxlength="16"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-radio-group v-model="addForm.active">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="addUser">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑用户"
      :visible.sync="editFormVisible"
      :width="dialogWidth"
      left
      v-if="permissions.indexOf('编辑') > -1"
    >
      <el-form
        :inline="true"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="所属部门">
          <el-select v-model="editForm.departmentId" placeholder="请选择" clearable>
            <el-option-group
              v-for="group in editForm.departments"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="item in group.departments"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roles">
          <el-select v-model="editForm.roles" multiple placeholder="请选择角色" clearable>
            <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-form-item label="账号" prop="username">
            <el-input
              v-model="editForm.username"
              placeholder="请输入账号"
              auto-complete="off"
              maxlength="64"
              clearable
            ></el-input>
          </el-form-item>
        </el-row>
        <el-form-item label="名字" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入名字"
            auto-complete="off"
            maxlength="64"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="editForm.sex" placeholder="请选择性别" clearable>
            <el-option v-for="item in sexs" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="editForm.mobile"
            placeholder="请输入手机号"
            auto-complete="off"
            maxlength="16"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="固定电话" prop="telephone">
          <el-input
            v-model="editForm.telephone"
            placeholder="请输入固定电话"
            auto-complete="off"
            maxlength="16"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="editForm.email"
            placeholder="请输入邮箱"
            auto-complete="off"
            maxlength="16"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-radio-group v-model="editForm.active">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateUser">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      v-if="permissions.indexOf('导入') > -1"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="buttonSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="department.name" label="部门"></el-table-column>
        <el-table-column prop="name" label="名字"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="role" label="角色"></el-table-column>
        <el-table-column prop="lastLoginTime" label="上次登录"></el-table-column>
        <el-table-column prop="active" label="状态"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      dialogWidth:
        document.body.clientWidth <= 1366
          ? "55%"
          : document.body.clientWidth > 1366 &&
            document.body.clientWidth <= 1920
          ? "45%"
          : "40%",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        username: "",
        nickname: "",
        name: "",
        mobile: ""
      },
      addForm: {
        username: "",
        password: "",
        name: "",
        sex: "",
        mobile: "",
        telephone: "",
        email: "",
        active: 1,
        departments: [],
        departmentId: ""
      },
      addFormRules: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur"
          },
          {
            min: 1,
            max: 64,
            message: "账号长度在1到64个字"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 64,
            message: "密码长度在1到64个字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur"
          }
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur"
          },
          {
            min: 1,
            max: 2,
            message: "性别长度在1到2个字"
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确"
          }
        ],
        telephone: [
          {
            required: false,
            message: "请输入固定电话",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "固定电话长度在1到255个字"
          }
        ],
        email: [
          {
            required: false,
            message: "请输入邮箱",
            trigger: "blur"
          },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "邮箱格式不正确"
          }
        ]
      },
      editForm: {
        username: "",
        password: "",
        name: "",
        sex: "",
        mobile: "",
        telephone: "",
        email: "",
        active: 1,
        departments: [],
        departmentId: ""
      },
      editFormRules: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur"
          },
          {
            min: 1,
            max: 64,
            message: "账号长度在1到64个字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur"
          }
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur"
          },
          {
            min: 1,
            max: 2,
            message: "性别长度在1到2个字"
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            pattern: /^1(3|4|5|7|8)\d{9}$/,
            message: "手机号格式不正确"
          }
        ],
        telephone: [
          {
            required: false,
            message: "请输入固定电话",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "固定电话长度在1到255个字"
          }
        ],
        email: [
          {
            required: false,
            message: "请输入邮箱",
            trigger: "blur"
          },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "邮箱格式不正确"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/user/upload`,
      fileList: [],
      permissions: [],
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      sexs: ["男", "女", "保密"],
      roles: [],
      parentDepartment: ""
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getUser() {
      this.api.user
        .getUser({ id: this.selection })
        .then(result => {
          this.editForm = result.data;
          this.editForm.departments = this.treeData[0].departments;
          this.editForm.roles.map(
            (e, index) => (this.editForm.roles[index] = e.id)
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.user
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addUser() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.roles.forEach(
            (e, index) => (this.addForm.roles[index] = { id: e })
          );
          this.api.user
            .addUser(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.addFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateUser() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editForm.roles.forEach(
            (e, index) => (this.editForm.roles[index] = { id: e })
          );
          this.api.user
            .updateUser(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteUser(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.user
            .deleteUser([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteUser() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.user
            .deleteUser(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.user
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.user
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    nodeFilter(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          if (a.url == this.$route.path) {
            a.resources.forEach(e => this.permissions.push(e.function));
          }
        });
      });
    },
    getRoleList() {
      this.api.role
        .getRoleList()
        .then(result => {
          this.roles = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    enableUser(row, active) {
      this.api.user
        .enable({
          id: row.id,
          active: active
        })
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getUser();
      }
    }
  },
  mounted() {
    this.getPermissionList();
    this.pageList();
    this.getRoleList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/index.vue